import * as yup from 'yup'

const validationSchema = (t) =>
  yup.object().shape({
    name: yup.string().required(t('specialty.form.error.name')),
    detail: yup.string().required(t('specialty.form.error.detail')),
  })

export default validationSchema
